(function (Drupal, $) {
  Drupal.behaviors.rows = {
    attach: function (context) {
      "use strict";

      $(once("rows-list-ready", ".rows-list", context))
        .each(function () {
          var _self = $(this);
          _self.find(".rows__title").on("click", function () {
            $(this).toggleClass("is-open");
            $(this).siblings(".rows__rows").stop().slideToggle(300);
          });

          const btnCollapseAll = _self.find(".btn-collapse-all");

          if (btnCollapseAll) {
            var collapsed = false;

            btnCollapseAll.on("click", function () {
              if (!collapsed) {
                _self
                  .find(".rows__title")
                  .removeClass("is-open")
                  .siblings(".rows__rows")
                  .stop()
                  .slideUp(300);

                $(this).text("Expand all");
                collapsed = true;
              } else {
                _self
                  .find(".rows__title")
                  .addClass("is-open")
                  .siblings(".rows__rows")
                  .stop()
                  .slideDown(300);
                $(this).text("Collapse all");
                collapsed = false;
              }
            });
          }
        });
    },
  };
})(Drupal, jQuery);
